export const GET_CUSTOMER_BY_BRANCH_ID = `
query GetAllSalePlanningCust(
  $input: TsalesPlanningCustWhereInput
  $skip: Float
  $take: Float
) {
  getSalesPlanningCust(where: $input, skip: $skip, take: $take, orderBy:{indexNum: ASC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      useYn
      customerId
      tsalesPlanningCustRemoveReason{
            id
            reason
            tcreateUser{
                id
                fullName
            }
            createDate
        }
      salesPlanningId
      indexNum
      customer {
        sapCustomerId
        id
        storeName
        address
        phone
        cccd
        taxId
        email
        latitude
        longitude
        urlImage1
        urlImage2
        urlImage3
        urlImage4
        urlImage5
        longitude
        latitude
        trankProcess{
            name
        }
        trankProduct{
            name
        }
        tward{
            name
        }
        tdistrict{
            name
        }
        tcity{
            name
        }
        trank{
            name
        }
      }
      tcheckinout{
        id
        checkInTime
        checkOutTime
      }
      createDate
      averageRevenue
    }
  }
}
`;

export const DEL_CUSTOMER_BY_ID = `mutation UpdateSalePlanning($input: TsalesPlanningCustInput!){
    updateSalesPlanningCust(input: $input){
        id
        salesPlanningId
        useYn
    }
}`;

// Get customer recommends
export const GET_CUSTOMER_RECOMMEND_BY_BRANCH = `query GetProposeCustToSalesPlanning($input: ProposeCustToSalesPlanningInput!,$skip:Float,$take:Float){
    getProposeCustToSalesPlanning(where:$input,skip:$skip,take:$take){
       pageInfo{
        totalItems
        totalPages
        hasNextPage
        hasPreviousPage
        itemsPerPage
        currentPage
       }
       items{
        customerId
        storeName
        phone
        latitude
        longitude
        routeId
        rankName
        useYn
        implementDate
        cityId
        cityName
        districtName
        wardName
        isInArea
       }
    }
}`;

// Get customer new recommends by area
export const GET_NEW_CUSTOMER_BY_AREA = `query GetCustomerRecommends($input: CustInAreaNotInSalePlanning!,$skip:Float,$take:Float){
    getProposeCustomerByArea(where: $input,skip:$skip,take:$take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
            customerId
            cityId
            cityName
            districtId
            districtName
            wardId
            wardName
            address
            storeName
            latitude
            longitude
            syncStatus
            rankId
            rankName
            salePlanningId
            routeId
            }
    }
}
`;

export const QUERY_UPDATE_LAT_LNG_CUSTOMER = `mutation UpdateCustomerLongLati($input: TcustomerInput!){
    updateCustomer(input: $input){
        id
        storeName
        longitude
        latitude
    }
}`;

export const GET_ALL_CUSTOMER = `
query GetCustomerByFilter($input: TcustomerWhereInput, $skip: Float, $take: Float) {
  getCustomer(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
        id
        storeName
        name
        firstName
        mainCustomerId
        mainCustomer{
            id
            storeName
            name
            sapCustomerId
        }
        sapCustomerId
        typeSap
        titleSap
        storeName
        taxId
        cccd
        passportId
        email
        phone
        gender
        dayofbirth
        address
        latitude
        longitude
        status
        shortName
        note
        approvalYn
        urlImage1
        urlImage2
        urlImage3
        urlImage4
        urlImage5
        approvalStatus
        tapprovalStatus{
            name
        }
        approvalStatus
        tapprovalStatus{
            name
        }
        tcustomerLineProduct{
            id
            lineProductId
            lineProducts{
                name
            }
            note
        }
        createDate
        tcreateUser{
            id
            fullName
        }
        modifyDate
        tmodifyUser{
            id
            fullName
        }
        cityId
        tcity{
            name
        }
        districtId
        tdistrict{
            name
        }
        wardId
        tward{
            name
        }
        cityNewId
        tcityNew{
            name
        }
        wardNewId
        twardNew{
            name
        }
        trank{
            id
            name
        }
      tcustomerPlants{
        id
        plantId
      }
    }
  }
}`;

export const GET_CUSTOMER_RANK = `
query GetCustomerRankComBoBox($input:TcodeWhereInput,$skip:Float,$take:Float){
    getCode(where:$input,skip:$skip,take:$take){
        pageInfo{
          currentPage
          hasNextPage
          hasPreviousPage
          itemsPerPage
          totalItems
          totalPages
        }
        items{
          id
          name
        }
    }
}`;

export const GET_STATUS_VIP = `
query GetStatusVipByCustomer($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}`;

export const GET_CUSTOMER_RANK_COMBO_BOX = `
query GetCustomerRankComBoBox($input:TcodeWhereInput,$skip:Float,$take:Float){
  getCode(where:$input,skip:$skip,take:$take){
      pageInfo{
          currentPage
          hasNextPage
          hasPreviousPage
          itemsPerPage
          totalItems
          totalPages
      }
      items{
          id
          name
      }
  }
}`;

export const GET_STATUS_CUSTOMER = `query GetStatusTeamSale($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}`;

export const GET_CUSTOMER_BY_ID = `query GetCustomer($input: TcustomerWhereInput, $skip: Float, $take: Float) {
  getCustomer(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      storeName
      phone
      rankId
      urlImage1
      urlImage2
      urlImage3
      urlImage4
      urlImage5
      trank {
        id
        name
        description
        createId
        createDate
      }
      taxId
      address
      cityId
      cityNewId
      tcityNew {
        name
      }
      branchId
      dayofbirth
      districtId
      email
      gender
      latitude
      longitude
      mainCustomerId
      sapCustomerId
      mainCustomer {
        id
        phone
        address
        dayofbirth
        email
        gender
        latitude
        longitude
        trank {
          id
          name
          description
          createId
          createDate
        }
      }
      rankProcess
      rankProduct
      trankProduct{
        id
        name
      }
      trankProcess{
        id
        name
      }
      status
      wardId
      wardNewId
      twardNew {
        name
      }
    }
  }
}`;

export const GET_CUSTOMER_COMBOBOX = `
query GetCustomer($input: TcustomerWhereInput,$skip: Float, $take: Float) {
  getCustomer(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items{
        id
        storeName
    }
  }
}`;
export const CREATE_CUSTOMER_PLANT = `
mutation CreateCustomerPlant($input:TcustomerPlantInput!){
    createCustomerPlant(input:$input){
        id
        plantId
        customerId
    }
}
`;

export const CREATE_CUSTOMER = `
mutation createCustomer($data: TcustomerInput!){
  createCustomer(input: $data){
      id
      name
      storeName
      phone
      cityId 
      cityNewId
      tcityNew {
          name
      }
      mainCustomerId
      taxId
      email
      districtId
      status
      gender
      dayofbirth
      cccd
      address
      wardId
      wardNewId
      twardNew {
          name
      }
      firstName
      longitude 
      latitude 
      typeSap
      titleSap
      shortName
      urlImage1
      urlImage2
      urlImage3
      urlImage4
      urlImage5
      note
      approvalYn
  }
}`;

// export const CREATE_CUSTOMER = `
// mutation createCustomer($data: TcustomerInput!){
//   createCustomer(input: $data){
//       id
//       name
//       storeName
//       phone
//       cityId
//       mainCustomerId
//       taxId
//       email
//       districtId
//       status
//       gender
//       dayofbirth
//       cccd
//       address
//       wardId
//       rankId
//       longitude
//       latitude
//       typeSap
//       titleSap
//       shortName
//       urlImage1
//       urlImage2
//       urlImage3
//       urlImage4
//       urlImage5
//       note
//   }
// }`;

//CreateCustomerLineProduct
export const CREATE_CUSTOMER_LINE_PRODUCT = `
mutation CreateCustomerLineProduct($input:[TcustomerLineProductInput!]!){
    createManyCustomerLineProduct(input:$input){
        id
        customerId
        lineProductId
        note
    }
}
    `;
export const GET_CUSTOMER_IN_PLANT_COMBOBOX = `
query GetCustomerInPlantComBoBox($input: CustomerInPlantInput, $skip: Float, $take: Float) {
  getCustomerInPlantComBoBox(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      storeName
      name
      taxId
      sapCustomerId
    }
  }
}`;

//CheckDuplicateTaxId
export const CHECK_DUPLICATE_TAX_ID = `
query CheckDuplicateTaxId($input:TcustomerWhereInput!){
    getCustomer(where:$input){
        items{
            id
            taxId
        }
    }
}`;

export const SEARCH_CUSTOMER_IN_ROUTE = `
  query getRouteCustomerByroute($input: TrouteDetailWhereInput){
      getRouteDetail (where: $input){
        items {
          id,
          routeId
          customer {
            taxId,
            id,
            sapCustomerId
          }
        }
      }
  }
`;

export const SEARCH_CUSTOMER_IN_TEAM_SALE = `
  query GetTeamSalesCust($input: TteamSalesCustWhereInput) {
      getTeamSalesCust(where: $input) {
          items {
              id
              custId
              teamSalesId
              useYn
              indexNum
              createDate
              createId
              modifyDate
              modifyId
          }
      }
  }
`;

export const SEARCH_CUSTOMER_IN_SALE_PLANNING = `
  query GetCustomerinSalePlanning($input: TsalesPlanningCustWhereInput) {
    getSalesPlanningCust(where:$input) {
      items {
        id
        customerId
        salesPlanningId
        customer{
          taxId
          id
          sapCustomerId
        }
      }
    }
  }
`;

export const UPDATE_CUSTOMER = `
mutation UpdateCustomer($input:TcustomerInput!){
  updateCustomer(input:$input){
    id
    storeName
    mainCustomerId
    name
    note
    storeName
    shortName
    address
    dayofbirth
    cccd
    cityId
    cityNewId
    tcityNew {
      name
    }
    wardId
    wardNewId
    twardNew {
      name
    }
    districtId
    longitude
    latitude
    phone
    taxId
    titleSap
    typeSap
    urlImage1
  }
}`;

export const CHECK_CUSTOMER_IS_MAIN_CUSTOMER = `
query CheckUserIsMainCustomer($input: TcustomerWhereInput) {
    getCustomer(where: $input) {
        items{
            id
        }
    }
} `;

export const CHECK_USER_INFO = `
query CheckUserSap($input: checkUserSapInput) {
  checkUserSap(where: $input) {
    status
  }
} `;

export const DELETE_CUSTOMER_LINE_PRODUCT = `
query DeleteManyCustomerLineProduct($input:DeleteManyInput!){
  deleteManyCustomerLineProduct(input:$input){
    status
    message
  }
}`;

export const GET_CUSTOMERS_IN_COMBOBOX = `
  query GetCustomer($input: TcustomerWhereInput,$skip:Float,$take:Float) {
    getCustomer(where: $input,skip:$skip,take:$take) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items{
        id
        storeName
        taxId
        sapCustomerId
      }
    }
  }
`;

export const CHECK_DUPLICATE_CCCD = `
query GetCustomer($input: TcustomerWhereInput) {
  getCustomer(where: $input) {
     items {
        id
        sapCustomerId
        cccd
        typeSap
    }
  }
}`;

export const GET_CUS_LIST = `query GetCUstomerList($input:GetCustomerList!){
    getCustomerList(input:$input){
        items{
            id
        storeName
        phone
        rankId
        urlImage1
        urlImage2
        urlImage3
        urlImage4
        urlImage5
        trank {
            id
            name
        }
        taxId
        address
        cityId
        cityNewId
        tcityNew {
            name
        }
        branchId
        dayofbirth
        districtId
        email
        gender
        typeSap
        latitude
        longitude
        mainCustomerId
        cccd
        sapCustomerId
        createDate
        mainCustomer {
            id
            name
            phone
            address
            dayofbirth
            email
            gender
            latitude
            longitude
            trank {
            id
            name
            }
        }
        status
        wardId
        wardNewId
        twardNew {
            name
        }
        }
    }
}`;

export const GET_REGION = `
query GetRegion($input: TregionWhereInput, $take: Float) {
  getRegion(where: $input, take: $take) {
    items {
      id
      cityId
      wardId
      cityName
      wardName
      regionName
      tcity {
        name
      }
      tward {
        name
      }
    }
  }
}
`;
